import { render } from "./OnlineOrderShowComponent.vue?vue&type=template&id=bb3bf9fe"
import script from "./OnlineOrderShowComponent.vue?vue&type=script&lang=js"
export * from "./OnlineOrderShowComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/onlineOrders/OnlineOrderShowComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "bb3bf9fe"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('bb3bf9fe', __exports__)) {
    api.reload('bb3bf9fe', __exports__)
  }
  
  module.hot.accept("./OnlineOrderShowComponent.vue?vue&type=template&id=bb3bf9fe", () => {
    api.rerender('bb3bf9fe', render)
  })

}


export default __exports__